import React, { Component, useState, useEffect } from 'react';
import tableau from 'tableau-api';
import ReportsProxy from 'api/reports/reportsProxy';
import { ReportSessionModes } from 'interfaces/reports/tableauReport';

class TableauReportView extends Component {
    componentDidMount() {
      this.initViz();
    }

    initViz() {
      if (this.viz) {
        this.viz.dispose();
      }

      const setSelectedTab = (tabName) => {
        if (this.props.setTab) {
          this.props.setTab(tabName.replaceAll(' ', ''));
        }
      }

      const getSheet = () => {
        return this.viz.getWorkbook().getActiveSheet();
      }

      const parseViewName = (url) => {
        const lastSlashIndex = url.lastIndexOf('/');

        if (lastSlashIndex < 0 || lastSlashIndex === (url.length - 1)) {
          return '';
        }

        return url.substring(lastSlashIndex + 1);
      }

      const sendTabSwitch = (viewName) => {
        if (!this.props.facilityID || !this.props.workBookHash || !this.props.trackingID) {
          return;
        }
          const tabSwitchData = {
            trackingID: this.props.trackingID,
            switchToTabName: viewName,
            notes: "User switched to new tab in report."
          }
          ReportsProxy.sendUserSessionData(this.props.facilityID, this.props.workBookHash, [tabSwitchData], ReportSessionModes.NEWTAB).catch((error) => {
            console.log(error);
          });
      }
      
      const isMobile = window.innerWidth <= 1024;
      const options = {
          hideTabs: true,
          device: isMobile ? 'mobile' : 'desktop',
      };
      this.viz = new window.tableau.Viz(this.vizContainer, this.props.url, options);
      this.viz.addEventListener("tabswitch", function (marks) {
          const mySheet = getSheet();
          const viewName = parseViewName(mySheet.getUrl());
          setSelectedTab(viewName);
          sendTabSwitch(viewName);
});
    }

    render() {
      return (
          <div ref={(div) => { this.vizContainer = div }}>
          </div>
      )
    }
}

export default TableauReportView;
